export const Url = "https://www.banaanadmin.com/"
//export const Url = "http://127.0.0.1:8000/"
//export const Url = "http://192.168.100.198:8000/"
